import { SelfHostedApiOptions } from "../types";

export const DefaultSimpleLoginOptions: SelfHostedApiOptions = Object.freeze({
  website: null,
  baseUrl: "https://app.simplelogin.io",
  token: "",
});
